// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "cc33c5c6a187eafe50d380a7304d0588" + ".css";
};